// index banner
$('.banner-slider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1
});


// index testimonials
$('.testimonial-slider').slick({
  dots: false,
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  prevArrow: $('.testimonial-left-arrow'),
  nextArrow: $('.testimonial-right-arrow')
});


// product faq
document.addEventListener("DOMContentLoaded", function (){

     document.querySelectorAll(".question").forEach(function (item){
        item.addEventListener("click", function (){
         this.parentElement.classList.toggle("active");

          // hide show div
         const nextdiv = this.nextElementSibling;
          if (window.getComputedStyle(nextdiv).display == "none"){
               nextdiv.style.display = "block";

          }else{
               nextdiv.style.display = "none";
          }

         // sibling process
         const topparent = this.parentElement.parentElement.children;
         for( let i=0; i < topparent.length; i++){
            const siblingcount = topparent[i];
            if(siblingcount != this.parentElement){
               siblingcount.classList.remove("active");
               const dataText = siblingcount.querySelector(".answer");
               dataText.style.display = "none";
            }
         }
        });

    });
});


// service page
document.addEventListener("DOMContentLoaded", function () {
  const titles = document.querySelectorAll('.accordion-title');
  const contents = document.querySelectorAll('.accordion-content');

  titles.forEach((title, index) => {
    title.addEventListener('click', () => {
      titles.forEach(t => t.classList.remove('active'));
      contents.forEach(c => c.classList.remove('active'));
      title.classList.add('active');
      document.querySelector(`.accordion-content[data-index="${index}"]`).classList.add('active');
    });
  });
});


// index banner scroll
$('.scrol-wrap').click(function() {
  const target = $('.index-brand-logo');
  if (target.length) {
    $('html, body').animate({
      scrollTop: target.offset().top
    }, 1000);
  } else {
    console.warn('Target section not found.');
  }
});

$('.brand-slider').slick({
  arrows: false,
  dots: false,
  infinite: true,
  autoplay: true,
  speed: 400,           // how long the slide animation lasts
  autoplaySpeed: 1200,  // lower = faster
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    { breakpoint: 1200, settings: { slidesToShow: 4 } },
    { breakpoint: 992,  settings: { slidesToShow: 3 } },
    { breakpoint: 768,  settings: { slidesToShow: 2 } },
    { breakpoint: 480,  settings: { slidesToShow: 1 } }
  ]
});


// === Percent counters for "Product Solutions Difference" ===
(function () {
  // Ease-out cubic for smoother finish
  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function animatePercent(el, duration) {
    if (el.dataset._counted) return;
    el.dataset._counted = "1";

    const finalText = (el.textContent || "").trim();   // e.g., "99.9%"
    const m = finalText.match(/^(\d+(?:\.\d+)?)%$/);
    if (!m) return;

    const target = parseFloat(m[1]);
    const decimals = m[1].includes('.') ? m[1].split('.')[1].length : 0;
    const ms = duration || 2000; // slower default
    let startTs = null;

    function step(ts) {
      if (!startTs) startTs = ts;
      let p = Math.min((ts - startTs) / ms, 1);
      p = easeOutCubic(p);
      const val = (target * p).toFixed(decimals);
      el.textContent = val + '%';
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  // Find stand-alone nodes that are just "80%" / "99.9%" / "100%"
  function findPercentNodes(scope) {
    const out = [];
    scope.querySelectorAll('*').forEach(node => {
      if (node.childElementCount === 0) {
        const t = (node.textContent || '').trim();
        if (/^\d+(?:\.\d+)?%$/.test(t)) out.push(node);
      }
    });
    return out;
  }

  // Limit to the “Product Solutions Difference” section by heading text.
  function getScope() {
    const heading = Array.from(document.querySelectorAll('h1,h2,h3,h4'))
      .find(h => h.textContent.trim().toUpperCase().includes('PUREST SOLUTIONS DIFFERENCE'));
    return heading ? (heading.closest('section,div,main') || document) : document;
  }

  function init() {
    const scope = getScope();
    const nodes = findPercentNodes(scope);

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(entries => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            animatePercent(e.target, 2000);
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.4 });
      nodes.forEach(n => io.observe(n));
    } else {
      nodes.forEach(n => animatePercent(n, 2000));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* === Robust typewriter with mobile overlay fix === */
;(() => {
  // CONFIG
  const PREFIX = "INVEST IN YOUR HEALTH WITH THE ";
  const PHRASES = [
    "PUREST CHOICE FOR YOUR FAMILY",
    "SMARTER WAY TO SAVE MONEY",
    "PROTECTION YOU DESERVE EVERY DAY",
    "CLEANEST WATER TECHNOLOGY AVAILABLE",
    "FINEST IN WATER FILTRATION" // final stays
  ];
  const TYPE_SPEED = 90;
  const BACK_SPEED = 60;
  const HOLD_AFTER_TYPE = 1600;
  const START_DELAY = 400;

  function findBannerHeading() {
    const scope = document.querySelector('.index-banner');
    if (!scope) return null;
    return scope.querySelector('h1.js-rotator') || null;
  }

  // Inject a one-time mobile CSS override that removes dark overlays
  function injectMobileFixCSS() {
    const id = 'prussian-blue-mobile-fix';
    if (document.getElementById(id)) return;
    const style = document.createElement('style');
    style.id = id;
    style.textContent = `
      @media (max-width: 767px) {
        /* Remove common dark overlays in hero */
        .index-banner::before,
        .index-banner::after,
        .index-banner [class*="overlay"],
        .index-banner .banner__overlay,
        .index-banner .hero__overlay,
        .index-banner .banner-caption,
        .index-banner .banner-content {
          background: transparent !important;
          background-color: transparent !important;
          opacity: 0 !important;
        }
        /* Ensure any slide pseudo overlays are transparent */
        .index-banner .slick-slide::before,
        .index-banner .slick-slide::after {
          background: transparent !important;
          opacity: 0 !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  // Walk ancestors of the heading and clear any inline dark backgrounds
  function clearAncestorBackgrounds(el) {
    if (!el) return;
    const root = el.closest('.index-banner') || document;
    let p = el.parentElement;
    while (p && p !== root.parentElement) {
      const bg = getComputedStyle(p).backgroundColor;
      if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') {
        p.style.background = 'transparent';
        p.style.backgroundColor = 'transparent';
      }
      p = p.parentElement;
    }
  }

  function setupTyper(el) {
    if (el.dataset._typecycle && !Shopify?.designMode) return;
    el.dataset._typecycle = '1';

    // Prepare container
    el.textContent = '';
    el.classList.add('typer-wrap');
    el.style.display = 'inline-block';
    el.style.position = 'relative';
    el.style.fontVariantLigatures = 'none';
    el.style.textTransform = 'uppercase';

    // Mobile fix
    if (window.matchMedia('(max-width: 767px)').matches) {
      injectMobileFixCSS();
      clearAncestorBackgrounds(el);
      el.style.backgroundColor = '#003151';   // Prussian blue
      el.style.color = '#ffffff';
      el.style.padding = '0.1em 0.25em';
      el.style.borderRadius = '8px';
      // Make sure long lines keep the chip effect across wraps
      el.style.boxDecorationBreak = 'clone';
      el.style.webkitBoxDecorationBreak = 'clone';
    }

    // Build structure: [prefix][suffix][caret]
    const prefixSpan = document.createElement('span');
    prefixSpan.className = 'typer-prefix';
    prefixSpan.textContent = PREFIX;

    const suffixSpan = document.createElement('span');
    suffixSpan.className = 'typer-suffix';
    suffixSpan.textContent = '';

    const caretSpan = document.createElement('span');
    caretSpan.className = 'typing-caret';
    caretSpan.setAttribute('aria-hidden', 'true');
    caretSpan.textContent = '|';

    el.append(prefixSpan, suffixSpan, caretSpan);

    // Ghost measurer to lock height and avoid layout jump
    const ghost = document.createElement('span');
    ghost.setAttribute('aria-hidden', 'true');
    const longest = PHRASES.reduce((a, b) => (a.length > b.length ? a : b), '');
    ghost.textContent = PREFIX + longest;
    ghost.style.position = 'absolute';
    ghost.style.left = '0';
    ghost.style.top = '0';
    ghost.style.visibility = 'hidden';
    ghost.style.pointerEvents = 'none';
    ghost.style.whiteSpace = 'normal';
    el.appendChild(ghost);

    requestAnimationFrame(() => {
      const h = ghost.offsetHeight;
      el.style.minHeight = h + 'px';
      ghost.remove();
    });

    // Caret visual
    caretSpan.style.display = 'inline-block';
    caretSpan.style.width = '0.6ch';
    caretSpan.style.marginLeft = '2px';
    caretSpan.style.animation = 'blink 1s step-start infinite';
    caretSpan.style.color = 'currentColor';

    // Accessibility
    el.setAttribute('aria-live', 'polite');
    el.setAttribute('aria-atomic', 'true');

    // Typing logic
    let iPhrase = 0;
    const finalIndex = PHRASES.length - 1;

    function typeSuffix(text, i = 0, done) {
      const span = el.querySelector('.typer-suffix');
      span.textContent = text.slice(0, i);
      if (i < text.length) {
        setTimeout(() => typeSuffix(text, i + 1, done), TYPE_SPEED);
      } else {
        setTimeout(done, HOLD_AFTER_TYPE);
      }
    }

    function backspaceSuffix(text, i = text.length, done) {
      const span = el.querySelector('.typer-suffix');
      span.textContent = text.slice(0, i);
      if (i > 0) {
        setTimeout(() => backspaceSuffix(text, i - 1, done), BACK_SPEED);
      } else {
        done();
      }
    }

    function cycle() {
      const suffix = PHRASES[iPhrase];
      typeSuffix(suffix, 0, () => {
        if (iPhrase < finalIndex) {
          backspaceSuffix(suffix, suffix.length, () => {
            iPhrase += 1;
            cycle();
          });
        } else {
          // Final phrase stays; remove the caret so it stops blinking
          el.querySelector('.typer-suffix').textContent = suffix;
          caretSpan.remove();
        }
      });
    }

    setTimeout(cycle, START_DELAY);
  }

  function init() {
    const el = findBannerHeading();
    if (el) setupTyper(el);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);

  // Inline @keyframes for caret
  (function ensureBlinkKeyframes(){
    const id = 'typer-blink-keyframes';
    if (document.getElementById(id)) return;
    const style = document.createElement('style');
    style.id = id;
    style.textContent = '@keyframes blink { 50% { opacity: 0; } }';
    document.head.appendChild(style);
  })();
})();

// === Build a seamless marquee from the existing .brand-slider ===
document.addEventListener('DOMContentLoaded', buildLogoMarqueeFromSlick);
document.addEventListener('shopify:section:load', buildLogoMarqueeFromSlick);

function buildLogoMarqueeFromSlick() {
  document.querySelectorAll('.brand-slider').forEach(function (slider) {
    // Avoid rebuilding if already replaced
    if (slider.dataset._marqueeBuilt === '1') return;

    // Collect logo HTML from your existing blocks
    var items = Array.from(slider.querySelectorAll('.item')).map(function (item) {
      return item.innerHTML; // keep inner markup
    });
    if (items.length === 0) return;

    // Make the marquee wrapper
    var marquee = document.createElement('div');
    marquee.className = 'logo-marquee';
    marquee.dataset.speed = slider.dataset.speed || '85'; // px/sec

    var track = document.createElement('div');
    track.className = 'logo-marquee__track';

    // One group (original)
    var groupA = document.createElement('div');
    groupA.className = 'logo-marquee__group';
    items.forEach(function (html) {
      var item = document.createElement('div');
      item.className = 'item';
      item.innerHTML = html;
      groupA.appendChild(item);
    });

    // Second group (duplicate for seamless loop)
    var groupB = document.createElement('div');
    groupB.className = 'logo-marquee__group';
    groupB.setAttribute('aria-hidden', 'true');
    items.forEach(function (html) {
      var item = document.createElement('div');
      item.className = 'item';
      item.innerHTML = html;
      groupB.appendChild(item);
    });

    track.appendChild(groupA);
    track.appendChild(groupB);
    marquee.appendChild(track);

    // Insert marquee after the old slider and hide the old slider
    slider.insertAdjacentElement('afterend', marquee);
    slider.style.display = 'none';
    slider.dataset._marqueeBuilt = '1';

    // Set duration so speed is constant regardless of screen or logo count
    function setDuration() {
      var groupWidth = groupA.getBoundingClientRect().width;
      var speed = parseFloat(marquee.dataset.speed) || 85; // px/sec
      if (groupWidth > 0) {
        var seconds = groupWidth / speed;
        track.style.setProperty('--marquee-duration', seconds + 's');
      }
    }

    // Recompute after images load and on resize
    var imgs = marquee.querySelectorAll('img');
    var pending = 0;
    imgs.forEach(function (img) {
      if (!img.complete) {
        pending++;
        img.addEventListener('load', function () { setTimeout(setDuration, 0); }, { once: true });
      }
    });
    setDuration();
    if (pending === 0) setDuration();
    window.addEventListener('resize', debounce(setDuration, 150));
  });
}

// simple debounce
function debounce(fn, delay){ let t; return function(){ clearTimeout(t); t=setTimeout(fn, delay); }; }

/* === Force FULL banner to Prussian blue on mobile (kill white parents) === */
(function forcePrussianBlueSection(){
  const ID = 'force-blue-banner-mobile-v2';
  if (document.getElementById(ID)) return;

  const style = document.createElement('style');
  style.id = ID;
  style.textContent = `
    @media (max-width: 767px) {
      /* Paint ALL key containers */
      .index-banner,
      .index-banner .banner-slider,
      .index-banner .slick-list,
      .index-banner .slick-track,
      .index-banner .slick-slide,
      .index-banner .banner-content,
      .index-banner .banner-caption {
        background: #003151 !important;
        background-color: #003151 !important;
      }

      /* Nuke dark/white overlays and pseudo-elements */
      .index-banner::before,
      .index-banner::after,
      .index-banner [class*="overlay"],
      .index-banner .banner__overlay,
      .index-banner .hero__overlay,
      .index-banner .slick-slide::before,
      .index-banner .slick-slide::after {
        background: transparent !important;
        background-color: transparent !important;
        opacity: 0 !important;
      }

      /* Ensure the heading reads well */
      .index-banner h1.js-rotator { color: #ffffff !important; }

      /* Optional: keep the type chip look off, letting the whole section be blue */
      .index-banner h1.js-rotator { 
        box-decoration-break: slice;
        -webkit-box-decoration-break: slice;
        background: transparent !important;
      }
    }
  `;
  document.head.appendChild(style);

  // Safety pass: remove inline backgrounds up the DOM that could stay white
  function clearInlineBG() {
    const root = document.querySelector('.index-banner');
    if (!root) return;
    let el = root;
    // clear children that might have inline bg styles
    root.querySelectorAll('*').forEach(n => {
      const bg = getComputedStyle(n).backgroundColor;
      if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') {
        n.style.background = '#003151';
        n.style.backgroundColor = '#003151';
      }
    });
  }

  if (window.matchMedia('(max-width: 767px)').matches) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', clearInlineBG);
    } else {
      clearInlineBG();
    }
    document.addEventListener('shopify:section:load', clearInlineBG);
    document.addEventListener('shopify:section:select', clearInlineBG);
  }
})();
/* === Fix CTA button colour on blue background (mobile) === */
(function fixCTAColour(){
  const ID = 'cta-blue-fix';
  if (document.getElementById(ID)) return;

  const style = document.createElement('style');
  style.id = ID;
  style.textContent = `
    @media (max-width: 767px) {
      /* Adjust CTA button text and arrow on Prussian-blue banner */
      .index-banner .btn,
      .index-banner .button,
      .index-banner .banner-button,
      .index-banner .cta-button {
        color: #ffffff !important;           /* white text */
        border-color: #ffffff !important;    /* keep white outline */
      }

      /* Make any embedded SVG or arrow icon white too */
      .index-banner .btn svg,
      .index-banner .button svg,
      .index-banner .banner-button svg,
      .index-banner .cta-button svg,
      .index-banner .btn path,
      .index-banner .button path,
      .index-banner .banner-button path,
      .index-banner .cta-button path {
        fill: #ffffff !important;
        stroke: #ffffff !important;
      }

      /* Optional hover state */
      .index-banner .btn:hover,
      .index-banner .button:hover,
      .index-banner .banner-button:hover,
      .index-banner .cta-button:hover {
        background: rgba(255, 255, 255, 0.15) !important;
        color: #ffffff !important;
      }
    }
  `;
  document.head.appendChild(style);
})();
